import React, { useRef, useState } from 'react';

import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { ListItemSecondaryAction } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

type MenuItem = {
  menuId: number;
  label: string;
  url: string;
  target: string;
  parentMenuId?: number;
  [key: string]: any;
};

export default function MobileMenu({ menuItems = [], navigate, cssId, contentLayout, scopedLayout, logoLink, mobileMenuPos, showLogo, logoSrc }) {
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
  const [openMenuOptionId, setOpenMenuOptionId] = useState<number | null>(null);
  const logoRef = useRef<any>();

  const toggleMenuOption = (id: number | null) => setOpenMenuOptionId(openMenuOptionId != id ? id : null);
  const toggleDrawer = (event: any) => setDrawerOpen(!drawerOpen);

  const imageStyle = {
    height: logoRef.current?.naturalHeight > logoRef.current?.naturalWidth ? '100%' : undefined,
    width: logoRef.current?.naturalHeight < logoRef.current?.naturalWidth ? '100%' : undefined,
    aspectRatio: `${logoRef.current?.naturalWidth} / ${logoRef.current?.naturalHeight}`,
  };

  const wrapStyle = {
    aspectRatio: `${logoRef.current?.naturalWidth} / ${logoRef.current?.naturalHeight}`,
  };

  return (
    <>
      {mobileMenuPos === 'RIGHT' && (
        <div className="menu-logo-wrap" style={wrapStyle}>
          {showLogo && logoSrc ? (
            <div className="menu-logo-wrap" style={wrapStyle}>
              {logoLink ? (
                <a href={logoLink}>
                  <img ref={logoRef} className="menu-logo" style={imageStyle} src={logoSrc} />
                </a>
              ) : (
                <img ref={logoRef} className="menu-logo" style={imageStyle} src={logoSrc} />
              )}
            </div>
          ) : null}
        </div>
      )}
      <IconButton aria-controls="simple-menu" className="hamburger" onClick={toggleDrawer} aria-haspopup="true">
        <MenuIcon />
      </IconButton>
      {mobileMenuPos === 'LEFT' && (
        <div className="menu-logo-wrap" style={wrapStyle}>
          {showLogo && logoSrc ? <img ref={logoRef} className="menu-logo" style={imageStyle} src={logoSrc} /> : null}
        </div>
      )}
      <Drawer id={cssId} PaperProps={{ className: 'cms-mobile-menu' }} anchor={mobileMenuPos?.toLowerCase()} open={drawerOpen} onClose={toggleDrawer}>
        <div role="presentation" onClick={toggleDrawer} onKeyDown={toggleDrawer}>
          <List className="menu-items">
            {(menuItems as MenuItem[])
              ?.filter(menuItem => !menuItem.parentMenuId)
              ?.map((item, index) => {
                const { url, target } = item;
                const hasSubMenu = (menuItems as MenuItem[]).some(menuItem => menuItem.parentMenuId === item.menuId);

                if (hasSubMenu) {
                  return (
                    <React.Fragment key={index}>
                      <ListItem
                        key={index}
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        onClick={e => {
                          e.stopPropagation();
                          toggleMenuOption(item.menuId);
                        }}
                      >
                        <ListItemText primary={item.label} />
                        <ListItemSecondaryAction>
                          <IconButton
                            onClick={e => {
                              e.stopPropagation();
                              toggleMenuOption(item.menuId);
                            }}
                          >
                            <ExpandMoreIcon />
                          </IconButton>
                        </ListItemSecondaryAction>
                      </ListItem>
                      {openMenuOptionId === item.menuId && (
                        <div style={{ marginLeft: 20 }}>
                          {(menuItems as MenuItem[])
                            .filter(menuItem => menuItem.parentMenuId === item.menuId)
                            .map(({ url, target, layoutCode, menuId, label }: MenuItem) => {
                              if (url?.startsWith('#')) {
                                return (
                                  <a href={url} className={`cms-menu-item no-underline text-inherit`}>
                                    {item.label}
                                  </a>
                                );
                              }

                              return (
                                <ListItem
                                  onClick={() => navigate(url, target)}
                                  className={`cms-menu-item ${
                                    scopedLayout ? scopedLayout.layoutCode === layoutCode : contentLayout.layoutCode === layoutCode ? 'active' : ''
                                  }`}
                                  style={{ margin: 0 }}
                                  button
                                  key={`mobile_${url}_${menuId}`}
                                >
                                  <ListItemText primary={label} />
                                </ListItem>
                              );
                            })}
                        </div>
                      )}
                    </React.Fragment>
                  );
                } else {
                  if (url?.startsWith('#')) {
                    return (
                      <div className='py-1.5 px-3.5'>
                        <a href={url} className={`cms-menu-item no-underline text-inherit`}>
                          {item.label}
                        </a>
                      </div>
                    );
                  }

                  return (
                    <ListItem
                      onClick={() => navigate(url, target)}
                      className={`cms-menu-item ${contentLayout.contentLayoutId === item.layoutId ? 'active' : ''}`}
                      button
                      style={{ margin: 0 }}
                      key={`mobile_${item.url}_${item.menuId}`}
                    >
                      <ListItemText primary={item.label} />
                    </ListItem>
                  );
                }
              })}
          </List>
        </div>
      </Drawer>
    </>
  );
}
